import { restHeartClient } from '..'

/**
 *
 * @param db
 * @param collection
 * @param id
 * @param data
 */
export function updateCollection(db: string, collection: string, data: object) {
	return restHeartClient.patch(`${db}/${collection}`, data)
}
